import * as React from "react"
// @ts-ignore
import {rightImage,saDefaultImageText,saDefaultImageTextSectionTitle,saDefaultImageTextGrid,saDefaultImageTextImage,saDefaultImageTextBlock,saDefaultImageTextTitleContainer,saDefaultImageTextTitle,saDefaultImageTextText } from './saDefaultImageText.module.scss'

import { saInterfaceImageText } from "../saTypes"
import { SaTitle } from "../saTitle/saTitle"
import SaImage from "../saImage/saImage"



const SaDefaultImageText:React.FC<saInterfaceImageText>  = ({ ...props }) =>  {


    return (
      <div className={'saContainer ' + saDefaultImageText}>

        {
          props.sectionTitle
          &&
          <div className={saDefaultImageTextSectionTitle}>
            <SaTitle title={props.sectionTitle}/>
          </div>
        }



        <div className={saDefaultImageTextGrid + ' ' + (!props.isLeftImage && rightImage)}>

          {
            props.image
            &&
            <div className={saDefaultImageTextImage}>
              <SaImage {...props.image} />
            </div>
          }

          <div  className={saDefaultImageTextBlock}>

            <div className={saDefaultImageTextTitleContainer}>
              <SaTitle title={props.title} classes={saDefaultImageTextTitle}/>
            </div>

            <div className={saDefaultImageTextText}
                 dangerouslySetInnerHTML={{__html: props.text}}/>

          </div>

        </div>


      </div>
    )

}

export default SaDefaultImageText